import * as angular from 'angular';
import {IController} from 'angular';
import * as _ from "lodash";
import {VisitPlanHttpService} from "../../angular/services/visit-plan-http.service";

export class SchedulingProjectTemplatesDisplayListCtrl implements IController {
  ids: string[];
  isRow: any;
  rowLimit: any;
  onChange: Function;

  public displayItems: any[];

  /* @ngInject */
  constructor(private visitPlanHttpService: VisitPlanHttpService, private $log: angular.ILogService, private $timeout: angular.ITimeoutService) {
  }

  $onInit() {
    if (!this.rowLimit) {
      this.rowLimit = 10;
    }
    this.setItems(this.ids);
  }

  $onChanges(changes) {
    if (changes.ids && !changes.ids.isFirstChange()) {
      this.setItems(this.ids);
    }
  }

  onRemoveItem(id) {
    this.onChange({
      ids: _.filter(this.ids, (i) => {
        return i !== id;
      })
    });
  }

  onReset() {
    this.onChange({ids: []});
  }

  private setItems(ids) {
    if (ids && ids.length) {
      this.visitPlanHttpService.getTemplates(ids.join(','), undefined, 100).subscribe({
        next: (response) => {
          this.$timeout(() => {
            const displayItems = [];
            _.forEach(response.list, (t: any) => {
              displayItems.push({id: t.id, value: t.name});
            });
            this.displayItems = displayItems;
          });
        },
        error: (error) => {
          this.$timeout(() => {
            this.$log.error('Failed to get templates for display list', error);
          });
        }
      });
    } else {
      this.displayItems = [];
    }
  }
}

angular
  .module('bringoz.admin.scheduling-project')
  .component('schedulingProjectTemplatesDisplayList', {
    bindings: {
      ids: '<',
      isRow: '<?',
      rowLimit: '<?',
      onChange: '&'
    },
    template: require('./scheduling-project-templates-display-list.html').default,
    controller: SchedulingProjectTemplatesDisplayListCtrl
  });
